import stockApi, { addTokenHeader } from '../StockApi'
import { resultToFailed, resultToSuccess } from '../Helper'

export const getActiveFulfillmentCenter = async (is_market = null) => {
  try {
    const authHeader = await addTokenHeader()
    const result = await stockApi.get('/v2/fulfillment-center/list', {
      ...authHeader,
      params: {
        active: true,
        is_market,
      },
    })
    return resultToSuccess(result)
  } catch (e) {
    return resultToFailed(e)
  }
}

const normalizeFulfillmentCenter = (fulfillmentCenter) => {
  if (!fulfillmentCenter) {
    return null
  }

  const type = fulfillmentCenter.type ?? fulfillmentCenter.fc_type ?? fulfillmentCenter.fcType
  const isMarketByType = typeof type === 'string' ? type !== 'FC' : undefined

  return {
    id: fulfillmentCenter.id ?? fulfillmentCenter.fulfillment_center_id ?? fulfillmentCenter.id_fulfillment_center,
    name: fulfillmentCenter.name ?? fulfillmentCenter.fulfillment_center_name,
    is_market: isMarketByType ?? fulfillmentCenter.is_market ?? fulfillmentCenter.isMarket ?? false,
    type,
    parent_fc: fulfillmentCenter.parent_fc ?? fulfillmentCenter.parentFc ?? null,
  }
}

const mapFulfillmentCentersFromAccess = (access) => {
  if (Array.isArray(access?.fulfillment_centers)) {
    return access.fulfillment_centers
      .map(normalizeFulfillmentCenter)
      .filter((fulfillmentCenter) => fulfillmentCenter?.id && fulfillmentCenter?.name)
  }

  if (Array.isArray(access?.fulfillmentCenters)) {
    return access.fulfillmentCenters
      .map(normalizeFulfillmentCenter)
      .filter((fulfillmentCenter) => fulfillmentCenter?.id && fulfillmentCenter?.name)
  }

  const fulfillmentCenter = normalizeFulfillmentCenter(
    access?.fulfillment_center || access?.fulfillmentCenter || access,
  )

  if (!fulfillmentCenter?.id || !fulfillmentCenter?.name) {
    return []
  }

  return [fulfillmentCenter]
}

export const getAvailableFulfillmentCenterAccess = async () => {
  try {
    const authHeader = await addTokenHeader()
    const result = await stockApi.get('/v2/fulfillment-center/access', authHeader)
    const accessList = Array.isArray(result.data?.data) ? result.data.data : []
    const fulfillmentCenters = accessList
      .flatMap(mapFulfillmentCentersFromAccess)
      .filter((fulfillmentCenter, index, list) => (
        list.findIndex((item) => item.id === fulfillmentCenter.id) === index
      ))

    return resultToSuccess({
      data: {
        ...result.data,
        data: fulfillmentCenters,
      },
      status: result.status,
      statusText: result.statusText,
    })
  } catch (e) {
    return resultToFailed(e)
  }
}
